import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { BUSINESS, CTA_TEXT } from "../data";

const ease = [0.22, 1, 0.36, 1];

export default function SubPageLayout({ title, subtitle, eyebrow, testid, children, metaDescription, hideCta = false }) {
  useEffect(() => {
    document.title = `${title} | ${BUSINESS}`;
    if (metaDescription) document.querySelector('meta[name="description"]')?.setAttribute("content", metaDescription);
    window.scrollTo(0, 0);
  }, [title, metaDescription]);
  return (
    <div className="App" data-testid={testid}>
      <Navbar />
      <section className="bg-[#172B38] text-[#F4F1E9] grain relative">
        <div className="wrap relative pt-20 pb-20 md:pt-28 md:pb-24 grid lg:grid-cols-12 gap-8">
          <motion.div className="lg:col-span-8" initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1, ease }}>
            {eyebrow && <p className="overline-hw text-[#8CAFC0] flex items-center gap-3"><span className="w-8 h-px bg-[#8CAFC0]" />{eyebrow}</p>}
            <h1 className="font-heading font-normal text-[2.9rem] sm:text-6xl lg:text-[4.6rem] leading-[1.04] mt-6">{title}</h1>
          </motion.div>
          <motion.div className="lg:col-span-4 self-end" initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1, ease, delay: 0.15 }}>
            {subtitle && <p className="text-[1.05rem] leading-relaxed text-[#F4F1E9]/75">{subtitle}</p>}
            {!hideCta && <Link to="/#schedule" data-testid="subpage-cta" className="btn-light mt-8">{CTA_TEXT} <ArrowRight className="w-4 h-4" strokeWidth={1.5} /></Link>}
          </motion.div>
        </div>
      </section>
      <main>{children}</main>
      <Footer />
    </div>
  );
}
